/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'logs-significance-options';
const prefix = `${moduleName}.${componentName}`;

export const nonSignificantLabel = `${prefix}.nonSignificantLabel`;
export const significantLabel = `${prefix}.significantLabel`;
export const userDefinedLabel = `${prefix}.userDefinedLabel`;
export const enableNonSignificantLogsMessage = `${prefix}.enableNonSignificantLogsMessage`;

export const ENGLISH = {
    [nonSignificantLabel]: 'Non-Significant',
    [significantLabel]: 'Significant',
    [userDefinedLabel]: 'User Defined',
    [enableNonSignificantLogsMessage]: 'Please enable Non-Significant logging in Virtual Service Settings.',
};
